<template>
    <div class="document-scanner">
        <div>
            <el-button type="primary" icon="el-icon-scan" :loading="isScanning" :disabled="isScanning" @click="startScan">
                {{ isScanning ? '正在扫描...' : '开始扫描' }}
            </el-button>
            <el-button type="primary" @click="onSubmit">提交</el-button>
        </div>

        <div class="box">
            <div v-if="errorMsg" class="error-msg">
                <el-alert :title="errorMsg" type="error" show-icon closable @close="errorMsg=''" />
            </div>

            <div v-if="scannedImages.length === 0 && errorMsg === ''" class="empty-placeholder">
                <i class="el-icon-folder-opened"></i>
                <span>暂无扫描件，点击上方按钮开始扫描</span>
            </div>

            <div v-if="scannedImages.length > 0" class="image-list">
                <h4>已扫描的图片 ({{ scannedImages.length }})</h4>
                <div class="image-grid">
                    <div class="image-card" v-for="(img, idx) in scannedImages" :key="idx">
                        <img :src="img.base64" alt="扫描件" />
                        <div class="a1ctions">
                            <el-button size="mini" icon="el-icon-download" @click="downloadImage(img.base64, idx)">下载</el-button>
                            <el-button size="mini" type="danger" icon="el-icon-delete" @click="removeImage(idx)">删除</el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    upFile,
} from "@/service/printApi.js";
export default {
    name: 'scannerPlugin',
    props: {
        bridgeUrl: {
            type: String,
            default: 'http://127.0.0.1:3000'
        },
        scanFlag: {
            type: Boolean,
            default: false
        },
        // 上传类型标识，随上传接口参数一起提交
        uploadType: {
            type: String,
            default: ''
        },
        timeout: {
            type: Number,
            default: 60000
        }
    },
    data() {
        return {
            isScanning: false,
            errorMsg: '',
            scannedImages: [],
            list: [],
        };
    },
    beforeDestroy() {
        this.cleanup();
    },
    methods: {
        startScan() {
            this.errorMsg = ''; // 清空上次错误
            this.isScanning = true;
            setTimeout(() => {
                this.isScanning = false;
            }, 2000);

            const messageId = Date.now() + '_' + Math.random();

            const handler = (event) => {
                if (event.origin !== new URL(this.bridgeUrl).origin) return;
                const data = event.data;
                console.log(event);
                console.log(data);
                if (data && data.messageId === messageId) {
                    if (data.type === 'SCAN_RESULT') {
                        if (data.images && data.images.length > 0) {
                            this.$message.success('扫描完成');
                            this.uploadImage(data.images)
                        } else {
                            this.errorMsg = '未获取到扫描图片';
                        }
                        this.cleanup(handler, timeoutId);
                    } else if (data.type === 'SCAN_CANCEL') {
                        // 取消扫描：不显示错误，仅提示并重置
                        this.$message.info('扫描已取消');
                        this.cleanup(handler, timeoutId);
                    } else if (data.type === 'SCAN_ERROR') {
                        // 扫描失败：显示错误，但按钮可用
                        console.log(data.message);
                        let errorMessage = data.message || '扫描过程发生错误';
                        // 处理JSON格式的错误信息，只保留中文提示
                        if (errorMessage.includes('{') && errorMessage.includes('}')) {
                            try {
                                // 提取JSON部分
                                const jsonStart = errorMessage.indexOf('{');
                                const jsonEnd = errorMessage.lastIndexOf('}') + 1;
                                const jsonString = errorMessage.substring(jsonStart, jsonEnd);

                                const errorObj = JSON.parse(jsonString);
                                console.log('解析后的错误对象:', errorObj);
                                if (errorObj.details) {
                                    // 提取中文部分
                                    const chinesePart = errorObj.details.match(/[\u4e00-\u9fa5\s\.，。！？]+/g);
                                    if (chinesePart && chinesePart.length > 0) {
                                        errorMessage = '扫描失败: ' + chinesePart.join('');
                                    } else {
                                        errorMessage = '扫描失败: 输稿器中未发现纸张';
                                    }
                                }
                            } catch (e) {
                                // 解析失败，使用默认错误信息
                                errorMessage = '扫描过程发生错误';
                            }
                        }
                        this.errorMsg = errorMessage;
                        this.cleanup(handler, timeoutId);
                    }
                }
            };

            window.addEventListener('message', handler);

            const timeoutId = setTimeout(() => {
                this.errorMsg = '扫描超时，请确认本地桥接服务是否正常';
                this.cleanup(handler, timeoutId);
            }, this.timeout);

            const newWindow = window.open(
                `${this.bridgeUrl}?messageId=${messageId}`,
                'scanWindow',
                'width=600,height=500'
            );

            if (!newWindow) {
                this.errorMsg = '浏览器阻止了弹窗，请允许弹出窗口后重试';
                this.cleanup(handler, timeoutId);
            }
        },

        cleanup(handler, timeoutId) {
            if (handler) {
                window.removeEventListener('message', handler);
            }
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            this.isScanning = false;
        },

        downloadImage(base64, idx) {
            const link = document.createElement('a');
            link.href = base64;
            link.download = `scan_${Date.now()}_${idx + 1}.jpg`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },

        removeImage(idx) {
            this.scannedImages.splice(idx, 1);
        },
        uploadImage(base64) {
            var token = sessionStorage.getItem("token");
            base64.forEach((val) => {
                var arr = val.split(','), mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                var timestamp = (new Date()).valueOf()
                const formData = new FormData()
                var fileliu = new File([u8arr], timestamp + '.jpeg', { type: mime })
                if (this.scanFlag) {
                    this.list.push(fileliu)
                } else {
                    formData.append('file', fileliu)
                    if (this.uploadType) {
                        formData.append('type', this.uploadType)
                    }
                    console.log(formData)
                    upFile(formData, token).then((res) => {
                        if (res.status === 200) {
                            this.scannedImages.push({
                                ...res.result[0],
                                base64: val,
                            })
                        }
                    });
                }
            })
        },
        onSubmit() {
            if (this.scanFlag) {
                if (this.list.length === 0) {
                    this.$message.warning('请先扫描文档');
                    return;
                }
                this.$emit('submit', this.list);
                this.list = [];
                this.scannedImages = [];
                this.errorMsg = '';
                return
            }
            if (this.scannedImages.length === 0) {
                this.$message.warning('请先扫描文档');
                return;
            }
            this.$emit('submit', this.scannedImages);
            this.scannedImages = [];
            this.errorMsg = '';
        }
    }
};
</script>

<style scoped>
.document-scanner {
    padding: 20px;
    background: #fff;
    border-radius: 4px;
}

.box {
    min-height: 65vh;
    width: 100%;
    border: 1px solid #ebeef5;
    margin-top: 20px;
    padding: 20px;
    background: #f5f7fa;
    border-radius: 4px;
    transition: all 0.3s;
}

.box:hover {
    border-color: #409eff;
}

.empty-placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 300px;
    color: #909399;
}

.empty-placeholder i {
    font-size: 60px;
    margin-bottom: 20px;
    color: #c0c4cc;
}

.error-msg {
    margin-top: 15px;
}

.image-list h4 {
    color: #303133;
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 15px;
    padding-left: 5px;
    border-left: 3px solid #409eff;
}

.image-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
}

.image-card {
    width: 180px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    padding: 10px;
    text-align: center;
    background: #fff;
    transition: all 0.3s;
    position: relative;
    overflow: hidden;
}

.image-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-color: #409eff;
}

.image-card img {
    width: 100%;
    height: 130px;
    object-fit: cover;
    margin-bottom: 10px;
    border-radius: 4px;
    background: #f5f7fa;
}

.actions {
    display: flex;
    gap: 8px;
    justify-content: center;
}

.actions ::v-deep .el-button {
    padding: 8px 12px;
}

.actions ::v-deep .el-button--mini {
    font-size: 12px;
}
</style>